<template>
  <section class="statisticAvailable">
    <div :class="['statisticAvailable__content', 'collapse__container', { 'collapse-active': !isCollapseOpen }]">
      <div class="statisticAvailable__header collapse__header">
        <p class="statisticAvailable__title">{{ `${totalWithoutDisabled} habitaciones en todo models 1a` }}</p>
        <button class="collapse__button" type="button" @click="toggleCollapse"><iconic name="chevronUp" /></button>
      </div>
      <div class="statisticAvailable__wrapper collapse__body">
        <pie-chart :donut="true" :data="dataToPie" height="198px" width="198px" :library="chartOptions"></pie-chart>
        <div class="statisticAvailable__contentValues">
          <div
            :class="['statisticAvailable__itemTotal', { 'statisticAvailable__itemTotal--pointer': key === 'modelos en línea' }]"
            v-for="(totalsRoom, key, idx) in totalsRooms"
            :key="key"
            :id="key"
            @mouseenter="activeTooltipKey = key"
            @mouseleave="activeTooltipKey = null"
          >
            <div class="statisticAvailable__contentName">
              <div class="statisticAvailable__colorPie" :style="`background: ${colorMap[key]};`" />
              <span class="statisticAvailable__name">{{ getDisplayName(key) }}</span>
              <div v-if="key === 'modelos en línea'" class="statisticAvailable__iconWrapper">
                <ToolTip class="statisticAvailable__toolTip" v-if="activeTooltipKey === key" text="Conectadas, no necesariamente transmitiendo." variant="down" />
                <iconic name="informationIcon" class="statisticAvailable__InfoIcon" />
              </div>
            </div>
            <span :class="['statisticAvailable__totalData', !['ocupadas', 'disponibles', 'deshabilitadas', 'global'].includes(key) ? 'statisticAvailable__totalData--gray' : '']">{{
              totalsRoom
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import ToolTip from "../../../components/atoms/ToolTip.vue";
  export default {
    components: { ToolTip },
    props: ["totalsRooms", "total"],
    data() {
      return {
        isCollapseOpen: true,
        heightFather: 0,
        activeTooltipKey: null,
        colorMap: {
          "modelos en línea": "#1f86cb",
          ocupadas: "#BD0909",
          disponibles: "#209E0C",
          deshabilitadas: "#9D9D9D",
          global: "#795548",
        },
        chartOptions: {
          responsive: true,
          colors: ["#BD0909", "#209E0C", "#9D9D9D"],
          plotOptions: {
            pie: {
              showInLegend: false,
              dataLabels: {
                enabled: false,
              },
            },
          },
          tooltip: {
            formatter: function() {
              const percentage = Math.round(this.point.percentage);
              return `${this.point.name}: ${percentage}%`;
            },
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            style: {
              color: "#fff",
              "text-transform": "Capitalize",
            },
          },
        },
      };
    },
    methods: {
      toggleCollapse: function() {
        const fatherElement = document.querySelector(".statisticAvailable");

        if (this.isCollapseOpen) {
          this.heightFather = fatherElement.offsetHeight;
        }
        this.$emit("toggleElementCollapse", {
          fatherIdOrClass: `.statisticAvailable`,
          fatherHeight: this.heightFather,
          isCollapseToClose: this.isCollapseOpen,
          fatherHeightCollapsed: 60,
          key: "available",
        });
        this.isCollapseOpen = !this.isCollapseOpen;
      },
      getDisplayName(key) {
        const nameMap = {
          ocupadas: "Ocupadas presencial",
          global: "Ocupadas global",
        };
        return nameMap[key] || key;
      },
    },
    computed: {
      dataToPie() {
        const filterData = Object.entries(this.totalsRooms).filter(([key, val]) => ["ocupadas", "disponibles", "deshabilitadas"].includes(key));
        return filterData.map(([key, val]) => [key, val]);
      },
      totalWithoutDisabled() {
        return this.total - (this.totalsRooms.deshabilitadas || 0);
      },
    },
    mounted() {
      const ocupadas = document.getElementById("ocupadas");
      const disponibles = document.getElementById("disponibles");
      const deshabilitadas = document.getElementById("deshabilitadas");
      const global = document.getElementById("global");
      const contenedor = ocupadas.parentNode;
      contenedor.appendChild(global);
      contenedor.appendChild(disponibles);
      contenedor.appendChild(deshabilitadas);
      contenedor.insertBefore(global, ocupadas);
    },
  };
</script>

<style lang="scss">
  .statisticAvailable {
    &__InfoIcon {
      color: #3d3d3d;
      margin-left: 5px;
      font-size: 16px;
    }
    &__toolTip {
      margin-left: 3px;
      margin-top: -3px;
    }
    height: auto;
    &__content {
      @include Flex(column, flex-start, flex-start);
      gap: 15px;
      width: 100%;
      background: #fff;
      border-radius: 9px;
      height: 100%;
      box-shadow: 0px 1px 4px 0px #00000040;
      padding-bottom: 15px;
      .collapse__header {
        padding: 15px;
      }
    }
    &__title {
      font-family: $sec-font;
      font-size: 24px;
    }
    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }
    &__wrapper {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 100%;
      height: 100%;
      gap: 15px;
      margin-top: 42px;
    }
    &__contentValues {
      @include Flex(column);
      gap: 10px;
    }
    &__itemTotal {
      @include Flex(row, space-between);
      width: 270px;
      gap: 5px;
      &--pointer {
        cursor: pointer;
      }
    }
    &__iconWrapper {
      position: relative;
      display: flex;
      align-items: center;
    }
    &__contentName {
      @include Flex(row);
      gap: 5px;
      position: relative;
    }
    &__colorPie {
      width: 11px;
      height: 11px;
      border-radius: 50px;
    }
    &__name {
      font-size: 18px;
      text-transform: lowercase;
      &::first-letter {
        text-transform: uppercase;
      }
    }
    &__totalData {
      @include Flex(row);
      width: 45px;
      height: 25px;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      background: $primary-color;
      border-radius: 9px;
      &--gray {
        background: #f0f0f0;
        color: #3d3d3d;
      }
    }
    @media (max-width: 700px) {
      &__wrapper {
        flex-wrap: wrap;
      }
    }
  }
</style>
